import actions from './actions'

const initState = {
    count: 1,
    color: 'black',
    isLogin: false,
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.INC_COUNT:
            return {
                ...state,
                ...{
                    count: state.count + action.payload.number,
                },
            }

        case actions.type.CHANGE_COLOR:
            return {
                ...state,
                ...{
                    color: action.payload.color,
                },
            }

        case actions.type.LOGIN:
            return {
                ...state,
                ...{
                    isLogin: action.payload.isLogin,
                },
            }

        default:
            return state
    }
}

export default reducer
